// App.js - WEB
import React, {PureComponent} from 'react';
import {
    View,
    Image,
} from 'react-native';
import LottieView from '../../../importCalss/LottieView';
import PathFile from '../../../assets/PathFile';
import {typeExport} from '../../../redux/store/type';
import i18n from '../../../I18n/i18n';
import {AsyngStorageClass} from '../../../tools/AsyngStorageClass';
import HMDialogWifiCheck from '../../../customviews/HMDialogWifiCheck';
import DialogConnectionCustomize from '../../../customviews/DialogConnectionCustomize';
import axios from 'axios';
import store from '../../../redux/store';
import {
    serviceActionAccount,
    serviceActionSetConnectionInternetHotspot,
    serviceActionSetToken, serviceActionSetUser,
    serviceActionTokenFirebase,
} from './action/ActionSplashSatiaScreen';
import * as NavigationService from '../../../redux/NavigationService';

let content = null;
let token = null;
let account = null;
export default class SplashSatiaScreen extends PureComponent {
    constructor(props) {
        super(props);
        content = this;
        this.state = {
            WifiCheck: false,
        };

    }

    async componentWillMount() {
        if (global.token_fb) {
            this.props.callServiceTokenFirebase(global.token_fb);
        }
        else {
            let fcmToken = await AsyngStorageClass.getASyng('fcmToken');
            this.props.callServiceTokenFirebase(fcmToken);


        }

        let token_fb = await AsyngStorageClass.getASyng('fcmToken');

        store.dispatch(serviceActionTokenFirebase(token_fb));

        token = await AsyngStorageClass.checkToken();
        store.dispatch(serviceActionSetToken(token));

        if (token) {
            let user = await AsyngStorageClass.getASyng(typeExport._USER);
            store.dispatch(serviceActionSetUser(user));

            account = await AsyngStorageClass.getASyng('Account');
            store.dispatch(serviceActionAccount(account, 0));

            if (account || typeExport._NameApp === 'SatiaOperator') {
                content.getData();

            }
            else {
                NavigationService.resetTo('ListAccountSatiaScreen');

            }
        }
        else {
            AsyngStorageClass.removeToken();
            NavigationService.resetTo('LoginStackScreen');
        }


    }

    componentDidMount() {

    }

    async getData() {

        if (token && typeExport._NameApp !== 'SatiaOperator')
        {
            try {
                NavigationService.navigatereset('DrawerScreen');

            }
            catch (e) {
                NavigationService.resetTo('DrawerScreen');

            }
        }
    else
        {
            let user_pass = await AsyngStorageClass.getASyng(typeExport._UserPassWifi);
            let password, username = null;
            if (user_pass) {
                username = user_pass.userWifi;
                password = user_pass.passWifi;

                axios(
                    {
                        //    url: `http://h.1547.ir/login?username=091895610009&password=863265`,
                        //  url: `http://h.1547.ir/login?username=09189648119&password=13981398`,
                        //  url: `http://h.1547.ir/login?username=09189557467&password=996633`,
                        url: `http://h.1547.ir/login?username=${username}&password=${password}`,
                        method: 'GET',
                        timeout: 2000,
                        headers: {
                            'Content-Type': 'text/html',
                        },
                    })
                    .then(async response => {
                        let data = response.data;
                        store.dispatch(serviceActionSetConnectionInternetHotspot((response.data.search('Thank You You Already Login') >= 0)));

                        content.setState({
                            isLoading: false,

                        });
                        // alert(response.status)
                    })
                    .catch((e) => {
                        content.setState({
                            isLoading: false,
                            // wifiConnectionStatus: true,

                        });
                        console.log('errorrequestLogin', e);
                    });
            }


            // let token = await AsyngStorageClass.checkToken();
            //
            //
            // let account = null;
            // if (token) {
            //     //  let user = await AsyngStorageClass.getASyng(typeExport._USER);
            //     // store.dispatch(serviceActionSetUser(user))
            //
            //     account = await AsyngStorageClass.getASyng("Account");
            //     // store.dispatch(serviceActionAccount(account, 0));
            // }

            //   let endDate = null;
            //let startDate = null;
            if (typeExport._NameApp == 'SatiaOperator') {
                this.props.callServiceSetTimeSpan(null, null, 0, 1);
                // endDate = moment().format('jYYYY/jM/jD');
                // let m = moment(endDate, 'jYYYY/jM/jD');
                // startDate = m.subtract(3, 'month').locale('fa').format('jYYYY/jM/jD');
            }


            let paramss = {
                'id': 1,
                'imei': 0,
                'token': token,
                'lang': i18n.locale,
                'beginDate': this.props.beginDate,
                'endDate': this.props.endDate,
                'token_fb': this.props.token_fb,
                //'Account': this.props.Account ? content.props.Account : null,
                'Account': account ? account : null,
            };

            content.props.callService(paramss, typeExport.TypeGetAllData, typeExport._GET);
            global._loadDataCount = 0;
        }

    }

    render() {
        const {navigation} = this.props;

        return (
            <View style={{flex: 1, alignItems: 'center', justifyContent: 'center'}}>
                {/*      <TouchableOpacity
                    onPress={() => {
                        navigation.replace("HomeScreen")
                    }}
                    style={{width: "100%", height: 100, alignItems: 'center', justifyContent: 'center'}}
                >
                    <Text>cdvsdfsdfsdds</Text>
                </TouchableOpacity>*/}
                <View
                    style={{
                        position: 'relative',
                        width: '100%',
                        height: '100%',
                        //  backgroundColor: '#eaeaea',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}>
                    {/*      <TouchableOpacity
                    onPress={() => {
                        navigation.replace("HomeScreen")
                    }}
                    style={{width: "100%", height: 100, alignItems: 'center', justifyContent: 'center'}}
                >
                    <Text>cdvsdfsdfsdds</Text>
                </TouchableOpacity>*/}

                    <LottieView
                        resizeMode="cover"
                        speed={.4}
                        style={{position: 'absolute', width: '100%', height: '100%'}}
                        autoSize={true}
                        source={PathFile.animation.pulse} autoPlay loop/>


                    <LottieView
                        speed={.6}
                        resizeMode="cover"
                        style={{
                            position: 'absolute',
                            width: typeExport._WIDTH / (1.2),
                            height: typeExport._WIDTH / (1.2),
                        }}
                        source={PathFile.animation.pulse} autoPlay loop/>

                    <LottieView
                        speed={.5}
                        resizeMode="cover"
                        style={{position: 'absolute', width: typeExport._WIDTH / 3, height: typeExport._WIDTH / 3}}
                        source={PathFile.animation.pulse} autoPlay loop/>

                    <View style={{
                        width: 120,
                        height: 120,
                        position: 'absolute',
                        borderRadius: 60,
                        justifyContent: 'center',
                        alignItems: 'center',
                        backgroundColor: '#fff',
                    }}>

                        {/*       <HMTextView
                                type={"bold"}
                                style={{
                                    position: 'absolute',
                                    bottom: 0,
                                    fontSize: 12),
                                    marginBottom: 6),
                                    color: Colors.blackLight,
                                    // marginTop: 10)
                                }}
                                text={Constant.NameApp}
                                //   text={"یببل"}
                            />*/}
                    </View>
                    <Image

                        resizeMode={'contain'}
                        style={{
                            width: 110,
                            height: 110,
                            //position: 'absolute',
                            //borderRadius: 50),
                            //  backgroundColor: Colors.white


                        }}
                        source={PathFile.image.logo}
                    />


                </View>
                {
                    (content.props.NoInternetDialog || content.props.NoInternetDialogSatia || content.props.NoInternetDialogShahrdar) ?
                        <DialogConnectionCustomize
                            WiFiReview

                            onPressWiFiReview={async () => {
                                this.setState({
                                    WifiCheck: true,
                                });
                            }}
                            onPress={async () => {
                                content.getData();
                            }
                            }/> : null
                }

                {
                    //(content.props.NoInternetDialog || content.props.NoInternetDialogSatia || content.props.NoInternetDialogShahrdar) && this.state.WifiCheck ?
                    this.state.WifiCheck ?

                        <HMDialogWifiCheck func={content.getData} onPressCancel={() => {
                            this.setState({
                                WifiCheck: false,
                            });
                        }
                        }/> : null
                }
            </View>

        );
    }
}
